// policySlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { PolicyState } from './policyTypes';
import {
  createPolicy,
  updatePolicy,
  deletePolicy,
  fetchPolicyById,
  fetchAllPolicies,
  fetchPolicyLog,
} from './policyAction';

const initialState: PolicyState = {
  policies: [],
  policyLog: [],
  selectedPolicy: undefined,
  loading: false,
  error: undefined,
};

const policySlice = createSlice({
  name: 'policies',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Policy
      .addCase(createPolicy.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createPolicy.fulfilled, (state, action) => {
        state.loading = false;
        state.policies.push(action.payload);
      })
      .addCase(createPolicy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Policy
      .addCase(updatePolicy.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updatePolicy.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.policies.findIndex((policy) => policy.Id === action.payload.Id);
        if (index !== -1) {
          state.policies[index] = action.payload;
        }
      })
      .addCase(updatePolicy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete Policy
      .addCase(deletePolicy.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deletePolicy.fulfilled, (state, action) => {
        state.loading = false;
        state.policies = state.policies.filter((policy) => policy.Id !== action.meta.arg.policyId);
      })
      .addCase(deletePolicy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Policy by ID
      .addCase(fetchPolicyById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchPolicyById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedPolicy = action.payload.data;
      })
      .addCase(fetchPolicyById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All Policies
      .addCase(fetchAllPolicies.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAllPolicies.fulfilled, (state, action) => {
        state.loading = false;
        state.policies = action.payload.data;
      })
      .addCase(fetchAllPolicies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      //policy log 
      .addCase(fetchPolicyLog.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchPolicyLog.fulfilled, (state, action) => {
        state.loading = false;
        state.policyLog = action.payload.data;
      })
      .addCase(fetchPolicyLog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
  },
});

export default policySlice.reducer;
